import { render } from "./GuiaReferencia.vue?vue&type=template&id=1cc2ca3a"
import script from "./GuiaReferencia.vue?vue&type=script&lang=js"
export * from "./GuiaReferencia.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\31\\s\\CCD\\hircasa-ccd-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__